<template>
    <div>
        <div class="map-container">
            <gmap-map
                    :center="center"
                    :zoom="5.8"
                    :options="mapStyle"
                    style="width:100%;  height: 600px;"

            >
                <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="openInfoWindow(m)"
                        :icon="{ url: require('../assets/tree-icon.png'), scaledSize: {width: 40, height: 40}}"
                >
                </gmap-marker>

                <gmap-info-window
                        @closeclick="window_open=false"
                        :opened="window_open"
                        :position="infowindowPosition"
                        :options="infoWindowOptions"
                >
                </gmap-info-window>

            </gmap-map>

        </div>

        <div class="stat-container">
            Total trees planted:
            <div class="stat">{{markers.length}}</div>
        </div>

        <div class="form-container">
                <h2>Have you planted a tree recently?</h2>
                <h3>Add your tree to our database</h3>
                <div class="form-row"><label for="name">Your name</label><input type="text" title="name" id="name" /></div>
                <div class="form-row">
                <label for="location">Tree location</label>
                    <gmap-autocomplete
                            id="location"
                            @place_changed="setPlace">
                    </gmap-autocomplete>
<!--                    <br />-->
<!--                    <button @click="addMarker">Add</button>-->
                </div>
            <div class="form-row"><label for="reason" class="textarea-label">Why?<br /><span class="caption">(max 200 characters)</span></label><textarea id="reason" title="reason" rows="5"></textarea></div>

            <div class="form-row"><div class="g-recaptcha" data-sitekey="6LeFs9AUAAAAAImFTDJEszj-JgghzkGEU-2zIpxA"></div></div>
            <div class="form-row"><input @click="addMarker" class="submit" type="submit" value="Add a tree" /></div>

        </div>
    </div>
</template>


<script>
    export default {
        name: "GoogleMap",
        data() {
            return {
                center: { lat: 54.4837939, lng: -4.0233732 },
                markers: [
                    { position: {lat: 51.6075888, lng: -0.1044713}, content: 'London'},
                    { position: {lat: 57.063035, lng: -6.53144}, content: 'Canna'},
                    { position: {lat: 57.104876, lng: -2.622312}, content: 'Aberdeen'},
                ],
                places: [],
                currentPlace: false,
                info_marker: null,
                infowindowPosition: null,
                infoWindowOptions: {
                    content: '',
                    //optional: offset infowindow so it visually sits nicely on top of our marker
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
                window_open: false,
                mapStyle: {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false,
                    disableAutoPan: true,
                    styles:
                        [
                            {
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f5f5f5"
                                    }
                                ]
                            },
                        {
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#616161"
                                }
                            ]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                {
                                    "color": "#f5f5f5"
                                }
                            ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#bdbdbd"
                                }
                            ]
                            },
                            {
                                "featureType": "administrative.neighborhood",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "poi",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#eeeeee"
                                }
                            ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#757575"
                                }
                            ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#e5e5e5"
                                }
                            ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                            },
                            {
                                "featureType": "road",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels.icon",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#757575"
                                }
                            ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#dadada"
                                }
                            ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#616161"
                                }
                            ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                            },
                            {
                                "featureType": "transit",
                                "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                            },
                            {
                                "featureType": "transit.line",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#e5e5e5"
                                }
                            ]
                            },
                            {
                                "featureType": "transit.station",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#eeeeee"
                                }
                            ]
                            },
                            {
                                "featureType": "water",
                                "stylers": [
                                {
                                    "color": "#ffeb3b"
                                }
                            ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                {
                                    "color": "#c9c9c9"
                                }
                            ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry.fill",
                                "stylers": [
                                {
                                    "color": "#78c4d4"
                                }
                            ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                            }
                        ]

                }
            };
        },

        mounted() {
            //this.geolocate();
            //this.addExistingMarkers();
        },

        methods: {
            // receives a place object via the autocomplete component
            setPlace(place) {
                this.currentPlace = place;
            },
            addMarker() {
                if (this.currentPlace) {

                    // var la = {lat: 51.6075888, lng: -0.1044713};
                    // this.markers.push({ position: la });
                    // la = {lat: 51.6073984, lng: -0.1099814};
                    // this.markers.push({ position: la });

                    window.console.log(this.currentPlace.geometry.location.lat() +','+this.currentPlace.geometry.location.lng());

                    const marker = {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    };
                    this.markers.push({ position: marker });
                    //this.places.push(this.currentPlace);
                    this.center = marker;
                    this.currentPlace = null;
                }
            },
            // addExistingMarkers() {
            //
            //     var existing = [
            //         {lat: 51.6075888, lng: -0.1044713},
            //         {lat: 57.063035, lng: -6.53144},
            //         {lat: 57.104876, lng: -2.622312},
            //     ];
            //
            //     for(var i=0; i<existing.length; i++) {
            //         this.markers.push({ position: existing[i] });
            //         this.places.push(this.currentPlace);
            //     }
            //
            //
            //
            //
            //
            //
            // },
            openInfoWindow (marker) {

                window.console.log(marker);
                this.window_open = true;
                this.infowindowPosition = marker.position;
                this.infoWindowOptions.content = marker.content;
            }
            // geolocate: function() {
            //     navigator.geolocation.getCurrentPosition(position => {
            //         this.center = {
            //             lat: position.coords.latitude,
            //             lng: position.coords.longitude
            //         };
            //     });
            // }
        }
    };
</script>